module.exports = __webpack_public_path__ + "cd27da2638f331781e6306c51bdcca4b.svg";